import StudentTabContainer from "../sections/StudentTabContainer.section";
// components
import { TableHeadCustom } from "../../../components/table";
// sections
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { DatePicker } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import InlineText, { InlineTextContainer } from "src/components/InlineText";
import Scrollbar from "src/components/scrollbar";
import AssessmentController from "src/controller/Assessment.controller";
import { PATH_DASHBOARD } from "src/routes/paths";

const TABLE_HEAD = [
  { label: "Q No.", align: "center" },
  { label: "Topic", align: "left" },
  { label: "Sub Topic", align: "left" },
  { label: "Score", align: "left" },
  { label: "Exclude", align: "center" },
];

const ASSESSMENT_GROUPS = {
  initial_assessment: "Initial",
  post_assessment: "POST Assessment",
};

let ASSESSMENT = null;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

let excludedQuestions = [];

function handleExcludeCheckbox(id) {
  return new Promise((resolve, reject) => {
    if (excludedQuestions.includes(id)) {
      excludedQuestions = excludedQuestions.filter((i) => i !== id);
    } else {
      excludedQuestions.push(id);
    }
    resolve();
  });
}

export default function AddAssessmentScoreTab() {
  const { id, assessment_id } = useParams();

  const [tableData, setTableData] = useState([]);
  const [assessment, setAssessment] = useState({});
  const [questionsAverage, setQuestionAverage] = useState(0);
  const [isSaveingAssessmentScore, setIsSaveingAssessmentScore] =
    useState(false);

  const handleSaveButton = () => {
    setIsSaveingAssessmentScore(true);
    const payload = { ...assessment, questions: tableData };

    payload.questions.forEach((i) => {
      if (excludedQuestions.includes(i._id)) {
        i.exclude = true;
      }
    });

    AssessmentController.update(assessment_id, payload)
      .then((res) => {
        window.Toast("Assessment updated successfully");
      })
      .catch((err) => {
        window.ToastError(
          "Something went worng. Unable to save assessment updated score."
        );
        console.error(`Api Error: ${err.message}`);
      })
      .finally(() => {
        setIsSaveingAssessmentScore(false);
      });
  };

  useEffect(() => {
    AssessmentController.get(assessment_id)
      .then((data) => {
        ASSESSMENT = data;
        setTableData(data.questions ?? []);
        setAssessment(data);
        data?.questions?.forEach((element) => {
          if (element.exclude) {
            excludedQuestions.push(element._id);
          }
        });
      })
      .catch((err) => console.error(`Api Error: ${err.message}`));
  }, []);

  const handleDataChange = (i) => {
    setAssessment((pre) => ({ ...pre, date_of_assessment: i }));
  };

  useEffect(() => {
    let selectedAverage = null;

    for (let index = 0; index < tableData.length; index++) {
      const element = tableData[index];
      if (selectedAverage == null) {
        selectedAverage = element.score;
      } else {
        if (selectedAverage !== element.score) {
          selectedAverage = null;
          break;
        }
      }
    }

    setQuestionAverage(selectedAverage);
  }, [tableData]);

  return (
    <StudentTabContainer
      title="Add Assessment Score"
      content={
        tableData.length > 0 ? (
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              color="error"
              onClick={() =>
                window.redirect(PATH_DASHBOARD.student.tab(id, "assessments"))
              }
            >
              Back
            </Button>
            <LoadingButton
              loading={isSaveingAssessmentScore}
              variant="contained"
              onClick={handleSaveButton}
            >
              Save
            </LoadingButton>
          </Stack>
        ) : (
          ""
        )
      }
    >
      <InlineTextContainer>
        <InlineText tag="Assessment" value={assessment?.title ?? "-"} />
        <InlineText
          tag="Group"
          value={ASSESSMENT_GROUPS[assessment?.group] ?? "-"}
        />
        {/* <InlineText tag="Score" value={assessment?.score ?? "-"} /> */}
        <InlineText
          tag="Program Name"
          value={assessment?.subject_code ?? "-"}
        />
      </InlineTextContainer>
      <Divider />
      <Stack
        direction="row"
        justifyContent="space-between"
        py={2}
        alignItems="center"
      >
        <FormControl>
          <FormLabel id="demo-row-radio-buttons-group-label">
            Mark All:
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            onChange={(e) => {
              setTableData((pre) => {
                return pre.map((i) => ({ ...i, score: e.target.value }));
              });
            }}
            value={questionsAverage ?? 0}
          >
            <FormControlLabel
              value="0"
              control={<Radio size="small" />}
              label="0%"
            />
            <FormControlLabel
              value="25"
              control={<Radio size="small" />}
              label="25%"
            />
            <FormControlLabel
              value="50"
              control={<Radio size="small" />}
              label="50%"
            />
            <FormControlLabel
              value="75"
              control={<Radio size="small" />}
              label="75%"
            />
            <FormControlLabel
              value="100"
              control={<Radio size="small" />}
              label="100%"
            />
          </RadioGroup>
        </FormControl>

        <Stack>
          <DatePicker
            label="Date"
            inputFormat="dd/MM/yyyy"
            value={assessment?.date_of_assessment ?? null}
            onChange={handleDataChange}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                size="small"
                sx={{ maxWidth: "200px" }}
                // error={!!error}
                // helperText={error?.message}
              />
            )}
          />
        </Stack>
      </Stack>
      <TableContainer sx={{ position: "relative", overflow: "unset" }}>
        <Scrollbar>
          <Table size={"small"} sx={{ minWidth: 800 }}>
            <TableHeadCustom headLabel={TABLE_HEAD} />

            <TableBody>
              {tableData.map((row, i) => (
                <StyledTableRow hover key={`${row._id}_${i}`}>
                  <StyledTableCell align="center" sx={{ width: "80px" }}>
                    {i + 1}
                  </StyledTableCell>
                  <StyledTableCell align="left">{row?.topic} </StyledTableCell>
                  <StyledTableCell align="left">
                    {row?.sub_topic}
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ minWidth: "330px" }}>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      onChange={(e) => {
                        setTableData((pre) => {
                          return pre.map((i) => {
                            if (i._id === row._id) {
                              i.score = e.target.value;
                              return i;
                            } else {
                              return i;
                            }
                          });
                        });
                      }}
                      value={row.score ?? "-"}
                    >
                      <FormControlLabel
                        value="0"
                        control={<Radio size="small" />}
                        label="0%"
                      />
                      <FormControlLabel
                        value="25"
                        control={<Radio size="small" />}
                        label="25%"
                      />
                      <FormControlLabel
                        value="50"
                        control={<Radio size="small" />}
                        label="50%"
                      />
                      <FormControlLabel
                        value="75"
                        control={<Radio size="small" />}
                        label="75%"
                      />
                      <FormControlLabel
                        value="100"
                        control={<Radio size="small" />}
                        label="100%"
                      />
                    </RadioGroup>
                  </StyledTableCell>
                  <StyledTableCell align="center" padding="checkbox">
                    <Checkbox
                      color="primary"
                      defaultChecked={excludedQuestions.includes(row._id)}
                      onChange={(e) => {
                        handleExcludeCheckbox(row._id);
                      }}
                    />
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </Scrollbar>
      </TableContainer>
    </StudentTabContainer>
  );
}
